import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ["button"]

    connect() {
        this.initializeAddButtons();
    }

    initializeAddButtons() {
        this.buttonTargets.forEach((button) => {
            button.addEventListener("click", () => {
                let wrapper = document.querySelector(button.dataset.modalTarget)?.closest(".accordion-section-wrapper")
                let target = document.querySelector(button.dataset.modalTarget)
                if (target && wrapper) {
                    let target_link = wrapper.querySelector(".section-link");
                    if (target_link.classList.contains("collapsed")) {
                        target_link.click()
                    }

                    let currentField = target.closest(".field");

                    if (currentField == null) return;

                    if (button.dataset.scrollOn === "true") {
                        setTimeout(function () {
                            currentField.scrollIntoView({behavior: 'smooth', block: 'start'})
                        }, 400);
                    }
                }
            });
        });
    }
}
